import { PurchaseOrderStatus } from "@redotech/cockroachdb-codegen/tables/inventory/purchase-order-status";
import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import {
  inboundShipmentIdFormat,
  locationIdFormat,
  purchaseOrderIdFormat,
  supplierIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updatePurchaseOrder = {
  name: "updatePurchaseOrder" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    poNumber: z.string(),
    reference: z.string().nullish(),
    supplierId: supplierIdFormat.schema.nullish(),
    locationId: locationIdFormat.schema.nullish(),
    fulfillmentGroupId: z.string().nullish(),
    currency: z.string(),
    status: createEnum(PurchaseOrderStatus),
    orderedAt: zExt.plainDate().nullish(),
    tags: z.array(z.string()),
    trackingUrl: z.string().nullish(),
    note: z.string().nullish(),
    noteToSupplier: z.string().nullish(),
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        quantity: z.number().int(),
        receivedQuantity: z.number().int(),
        damagedQuantity: z.number().int(),
        unitCost: z.number(),
        costCurrency: z.string(),
        totalTax: z.number(),
        taxCurrency: z.string(),
        packingTemplateId: packingTemplateIdFormat.schema.nullish(),
      }),
    ),
    shipments: z.array(
      z.object({
        id: inboundShipmentIdFormat.schema.optional(),
        locationId: locationIdFormat.schema.nullish(),
        carrier: z.string().nullish(),
        estimatedArrivalDate: zExt.plainDate().nullish(),
        shipmentId: z.string().nullish(),
        trackingNumber: z.string().nullish(),
        trackingUrl: z.string().nullish(),
        freightCost: z.number(),
        freightCurrency: z.string(),
        dutyCost: z.number(),
        dutyCurrency: z.string(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
